import VueI18n from 'vue-i18n';
import {
	FullUser,
	UserSalutation,
	PartialUser,
	GroupMember,
	GroupMemberWithEmail,
	UserRole,
	UserDetailRole,
	PROFESSIONAL_ROLES,
} from '@front-app/services/UserApi/UserModel';

export function getUsername(t: typeof VueI18n.prototype.t, user: PartialUser): string {
	if (user.displayName) {
		if (user.salutation === UserSalutation.NONE) {
			return user.displayName;
		}
		return `${t(user.salutation)} ${user.displayName}`;
	}
	if (user.salutation === UserSalutation.NONE) {
		return `${user.firstName} ${user.lastName}`;
	}
	return `${t(user.salutation)} ${user.firstName} ${user.lastName}`;
}

export function getGroupMemberName(t: typeof VueI18n.prototype.t, user: GroupMember): string {
	if (user.groupRole === UserRole.EXTERNAL_INVITEE) {
		return getUsername(t, { ...user, salutation: UserSalutation.NONE });
	}
	return getUsername(t, user);
}

export function checkIfUserIsEmpty(user: FullUser): boolean {
	if (user.summaryForAll) {
		return false;
	}
	if (user.summaryForContacts) {
		return false;
	}
	if (user.currentOccupation.employer.name) {
		return false;
	}
	if (user.professionalExperiences.length > 0) {
		return false;
	}
	if (user.interests.length > 0) {
		return false;
	}
	if (user.associations.length > 0) {
		return false;
	}
	return true;
}

export function isExternalMember(user: GroupMemberWithEmail | GroupMember): user is GroupMemberWithEmail {
	return user.groupRole === UserRole.EXTERNAL_INVITEE;
}

export function hasValidRolesForSpecialty(roles: UserDetailRole[]) {
	let result = false;

	// eslint-disable-next-line no-restricted-syntax
	for (let role of roles) {
		if (PROFESSIONAL_ROLES.includes(role)) {
			result = true;
			break;
		}
	}

	return result;
};
